var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { memo } from "react";
const SvgVisa = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 52 18"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#2566AF",
  d: "M22.543 17.217h-4.244L20.951.793h4.244l-2.652 16.424ZM14.73.793 10.685 12.09l-.479-2.432L8.78 2.273S8.606.793 6.766.793H.078L0 1.072s2.045.428 4.438 1.877l3.687 14.268h4.42L19.297.793H14.73Zm33.374 16.424H52L48.603.793h-3.41c-1.576 0-1.96 1.224-1.96 1.224l-6.328 15.2h4.423l.885-2.44h5.394l.497 2.44Zm-4.67-5.81 2.23-6.146 1.255 6.146h-3.484Zm-6.197-6.664.606-3.527S35.974.5 34.026.5c-2.105 0-7.106.927-7.106 5.437 0 4.243 5.869 4.295 5.869 6.524s-5.264 1.83-7.001.424l-.631 3.688s1.895.927 4.79.927 7.263-1.51 7.263-5.623c0-4.27-5.922-4.667-5.922-6.524 0-1.857 4.133-1.618 5.949-.61Z"
})));
const Memo = /*#__PURE__*/memo(SvgVisa);
export default Memo;